module.exports = __webpack_public_path__ + "static/media/logoCompanyColor-old.5ee46cc0.svg";